import JsonLd from "@/components/base/JsonLd";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import NewArrivals from "./components/NewArrivals";
import Testimonials from "./components/Testimonials";
import EditorialSection from "./components/EditorialSection";
import DesignerSpotlight from "./components/DesignerSpotlight";
import ServicesBar from "./components/ServicesBar";
import Footer from "./components/Footer";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Clientizah",
    url: siteUrl,
    logo: "https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/dcebc87a-58a3-4ffb-968a-f62b795ba830_Slide1.jpg?v=bc79b70c22265c0c2e700194fd5ef66f",
    description:
      "Clientizah é a plataforma de educação em varejo criada por Gleice Lyra. Oferece o Método C.A.T para vendedoras, gerentes e lojistas.",
    sameAs: [],
    founder: {
      "@type": "Person",
      name: "Gleice Lyra",
      jobTitle: "Fundadora e Especialista em Varejo",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Clientizah",
    url: siteUrl,
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${siteUrl}/nossos-produtos`,
      },
      "query-input": "required name=search_term_string",
    },
  },
];

export default function Home() {
  return (
    <div className="relative min-h-screen bg-white">
      <title>Clientizah | Método C.A.T — Vendas, Varejo e Liderança</title>
      <meta name="description" content="Descubra o Método C.A.T da Clientizah — formação completa em vendas, varejo e liderança para vendedoras, gerentes e lojistas. +12.000 alunos. Criado por Gleice Lyra." />
      <meta name="keywords" content="método CAT, Clientizah, Gleice Lyra, curso de vendas, treinamento varejo, liderança varejo, curso gerente loja, curso lojista, WhatsApp Business, TikTok Shop, IA varejo" />
      <link rel="canonical" href={siteUrl} />
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <NewArrivals />
        <Testimonials />
        <EditorialSection />
        <DesignerSpotlight />
        <ServicesBar />
      </main>
      <Footer />
    </div>
  );
}
